import React, { useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { Slide } from "@progress/kendo-react-animation";
import "./Slide.scss";

/**
 * Slide animation
 * @module
 * @param {bool} isOpen - Is slide open?
 * @param {element} children - Children element
 * @param {func} onClose - Function invoked on close
 */
const SlideComponent = (props) => {
  const ref = useRef();
  const { isOpen, onClose } = props;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isOpen && !ref.current.contains(event.target)) {
        onClose();
      }
    };
    document.addEventListener("mousedown", handleClickOutside, false);

    return () =>
      document.removeEventListener("mousedown", handleClickOutside, false);
  }, [isOpen, onClose]);

  return (
    <div className="slide">
      <Slide className={isOpen ? " opened" : ""}>{isOpen ? <div ref={ref}>{props.children}</div> : null}</Slide>
      {isOpen ? <div className="overlay"></div> : null}
    </div>
  );
};

SlideComponent.propTypes = {
  children: PropTypes.element.isRequired,
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default SlideComponent;
